import { ExpandMore } from "@mui/icons-material";
import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Box, Grid, TextField } from "@mui/material";
import { DateTimePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { Controller, useFormContext, useFormState, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { cbErrorSectionValidationState, defaultBuagClassesState, isGlobalEditModeState, isMobilityVoucherModeState, mobilePrefixState, sapEnumState } from "../state/customerbaseState";
import { CBCountry, CBCountryExtended, CBCreationOfProps, CBInvoicingCode, CBLabel, CBOmissionType, CBPartnerType, CBRoleKey, CBYesNoType, IFormValues } from "../types";
import UpdateBtnsAccordion from "./UpdateBtnsAccordion";
import CBFormTextFieldController from "./formController/CBFormTextFieldController";
import FormController from "./formController/FormController";

interface CustomerBaseDetailsProps extends CBCreationOfProps {
    handleCheckCustomerExistenceOnBlur: (labelCheck: string) => void
}

const CustomerBaseDetails = ({ creationOf, handleCheckCustomerExistenceOnBlur} : CustomerBaseDetailsProps) => {


    //const { dispatchGlobalData } = useContext(GlobalContext);
    const { t } = useTranslation('customerbase');
    //const { id } = useParams();
    const isCreationMode = !!creationOf;
    //const isOrganizationCreation = useLocation().pathname.includes("organization-create");
    const formContext = useFormContext<IFormValues>();
    const formState = useFormState<IFormValues>({control: formContext.control});
    const isGlobalEditMode = useRecoilValue(isGlobalEditModeState);
    const editing = isGlobalEditMode;
    const sapEnum = useRecoilValue(sapEnumState);
   // const [queryFields, setQueryFields] = useState<IEditCustomerBaseFieldsParams>();
    //const customerQuery = useGetCustomerByIdMetaQueryObserver(id);
    const isPerson = formContext.getValues("cbDetails.partnerType") == CBPartnerType.PERSON;
    const mobilePrefixes = useRecoilValue(mobilePrefixState);

    const publicAuthorityWatch = useWatch<IFormValues, 'cbPersonalInfo.publicAuthority'>({name: "cbPersonalInfo.publicAuthority"});
    
    //const setErrorPaymentInfoSection = useSetRecoilState(errorPaymentInfoSectionState);
    const setErrorSection = useSetRecoilState(cbErrorSectionValidationState);
    const isMobilityVoucherMode = useRecoilValue(isMobilityVoucherModeState);
    
    const setDefaultBuagClasses = useSetRecoilState(defaultBuagClassesState);
    
    /** Edit a Sezioni */
    //const setAnotherSectionIsInEdit = useSetRecoilState(anotherSectionIsInEditState);
    /*const [isExpanded, setIsExpanded] = useState(true);
    const [editing, setEditing] = useState(isDirty(formState.dirtyFields, "cbDetails") && !isCreationMode);
    const openModal = useRecoilValue(openCustomerBaseModal);
    const setOpenCustomerBaseModal = useSetRecoilState(openCustomerBaseModal);
    const setQueryFields = useSetRecoilState(queryFieldsState);
    const [openRoleConfigurationModal, setOpenRoleConfigurationModal] = useState<{open: boolean, showIcon: boolean}>({
        open: false,
        showIcon: false
    });
    const [roleConfigurationData, setRoleConfigurationData] = useState<IRoleConfigurationFormValues | null>(null);
    const [defaultRoleConfigurationData, setDefaultRoleconfigurationData] = useState<IRoleConfigurationFormValues | null>(null);
    const cbEditButtonTrigger = useRecoilValue(cbEditButtonTriggerState);
    const setCbEditButtonTrigger = useSetRecoilState(cbEditButtonTriggerState);*/
    /** */

    /** Edit a Sezioni */
    /*useEffect(() => {
        
        if(cbEditButtonTrigger.cbDetails == CBEditButtonTriggerStatus.UPDATED) {
            if(!!roleConfigurationData) resetRoleConfigurationMode();
            setEditing(false);
            setAnotherSectionIsInEdit(false);
            setCbEditButtonTrigger({...cbEditButtonTrigger, cbDetails: CBEditButtonTriggerStatus.UNDEFINED});
        }

    }, [cbEditButtonTrigger.cbDetails])*/

    /*useEffect(() => {
        
        if(openModal && editing && !isDirty(formState.dirtyFields, "cbDetails")){
            setEditing(false);
            if(!!roleConfigurationData) resetRoleConfigurationMode();
        }
    }, [isDirty(formState.dirtyFields, "cbDetails")]);*/

    /*const onResetForm = useCallback((event: SyntheticEvent) => {
        event.stopPropagation();
        console.log(formState)
        if(formState.dirtyFields.cbDetails) setOpenCustomerBaseModal(true);
        else {
            if(!!roleConfigurationData) resetRoleConfigurationMode();
          
            setEditing(false);
            formContext.clearErrors("cbDetails");
            setAnotherSectionIsInEdit(false);
        }
       
    }, [formState, roleConfigurationData, formContext]);

    const onSetEditing = useCallback((event: SyntheticEvent) => {   
        event.stopPropagation();

        if(formState.isDirty) setOpenCustomerBaseModal(true);
        else setEditing(true);

    }, [formState]);

    const onSubmit = (params: any) => {
        console.log("OnSubmit params: ", params);

        const cbCustomerId = formContext.getValues("cbDetails.cbCustomerId");
        const bpCode = formContext.getValues("cbDetails.bpCode");
        const mobilePrefix = formContext.getValues("cbDetails.mobilePrefix");
        const mobile = formContext.getValues("cbDetails.mobile");
        //const email = formContext.getValues("cbDetails.email");

        var addresses: any[] = [];
        var payments: any[] = [];
        if(!!roleConfigurationData) {

            if(!!roleConfigurationData.residenceStreet && !! roleConfigurationData.residenceHouseNumber && !!roleConfigurationData.residenceZipCode
            && !!roleConfigurationData.residenceProvince && !!roleConfigurationData.residenceCity && !!roleConfigurationData.residenceCountry) {
                addresses.push({
                    id: roleConfigurationData.residenceAddressId || null,
                    cbCustomerId: cbCustomerId || null,
                    addressNumber: roleConfigurationData.residenceAddressNumber || null,
                    street: roleConfigurationData.residenceStreet,
                    houseNumber: roleConfigurationData.residenceHouseNumber,
                    zipCode: roleConfigurationData.residenceZipCode,
                    province: roleConfigurationData.residenceProvince,
                    city: roleConfigurationData.residenceCity,
                    country: roleConfigurationData.residenceCountry,
                    addrEmail: roleConfigurationData.residenceAddrEmail,
                    //addrMobile: mobile == "--" && (!mobilePrefix || mobilePrefix == "--" ) ? null : (mobilePrefix + mobile),
                    addrMobile: roleConfigurationData.residenceAddrMobile,  
                    addressType: CBAddressType.RESIDENCE
                });
            }

            if(!!roleConfigurationData.invoicingStreet && !!roleConfigurationData.invoicingHouseNumber && !!roleConfigurationData.invoicingZipCode
            && !!roleConfigurationData.invoicingProvince && !!roleConfigurationData.invoicingCity && !!roleConfigurationData.invoicingCountry
            && !!roleConfigurationData.invoicingAddrEmail //&& !!roleConfigurationData.invoicingPec && params.invoicingAddrMobile == "--"
            //&& roleConfigurationData.invoicingTelephone == null && roleConfigurationData.invoicingFax == null && roleConfigurationData.invoicingWebsite == null && !!roleConfigurationData.invoicingRecipientCode
            ){
                addresses.push({
                    id: roleConfigurationData.invoicingAddressId || null,
                    cbCustomerId: cbCustomerId || null,
                    addressNumber: roleConfigurationData.invoicingAddressNumber || null,
                    street: roleConfigurationData.invoicingStreet,
                    houseNumber: roleConfigurationData.invoicingHouseNumber,
                    zipCode: roleConfigurationData.invoicingZipCode,
                    province: roleConfigurationData.invoicingProvince,
                    city: roleConfigurationData.invoicingCity,
                    country: roleConfigurationData.invoicingCountry,
                    addrEmail: roleConfigurationData.invoicingAddrEmail,
                    pec: roleConfigurationData.invoicingPec,
                    //addrMobile: mobile == "--" && (!mobilePrefix || mobilePrefix == "--" ) ? null : (mobilePrefix + mobile),
                    addrMobile: roleConfigurationData.invoicingAddrMobile,
                    telephone: !!roleConfigurationData.invoicingTelephone ? roleConfigurationData.invoicingTelephone : null,
                    fax: !!roleConfigurationData.invoicingFax ? roleConfigurationData.invoicingFax : null,
                    website: !!roleConfigurationData.invoicingWebsite ? roleConfigurationData.invoicingWebsite : null,
                    companyFiscalCode: !!roleConfigurationData.invoicingCompanyFiscalCode ? roleConfigurationData.invoicingCompanyFiscalCode : null,
                    //recipientCode: roleConfigurationData.invoicingRecipientCode,
                    recipientCode: !!roleConfigurationData.invoicingRecipientCode ? roleConfigurationData.invoicingRecipientCode : null,
                    addressType: CBAddressType.INVOICING
                });
            }

            if(!!roleConfigurationData.paymentInfo && roleConfigurationData.paymentInfo.length > 0) {
                payments = formContext.getValues("cbPaymentInfo").filter(p => !(roleConfigurationData.paymentInfo?.findIndex(rp => p.id == rp.id) !== -1)).map(p => ({
                    id: p.id || null,
                    buagId: p.buagId || null,
                    iban: p.iban !== "--" ? p.iban?.toUpperCase() || null : null,
                    accountHolder: p.accountHolder !== "--" ? p.accountHolder || null : null,
                    referenceDetails: p.referenceDetails !== "--" ? p.referenceDetails || null : null,
                    paymentMethod: p.paymentMethod || null,
                    paymentTerms: p.paymentTerms || null,
                    correspondingVariant: p.correspondingVariant || null
        
                }));
        
                roleConfigurationData.paymentInfo?.forEach(p => {
                    payments.push({
                        id: p.id || null,
                        buagId: p.buagId || null,
                        iban: p.iban !== "--" ? p.iban || null : null,
                        accountHolder: p.accountHolder !== "--" ? p.accountHolder || null : null,
                        referenceDetails: p.referenceDetails !== "--" ? p.referenceDetails || null : null,
                        paymentMethod: p.paymentMethod || null,
                        paymentTerms: p.paymentTerms || null,
                        correspondingVariant: p.correspondingVariant || null
                    });
                });

            }
            
        }

        //console.log("There's RoleConfigData? ", !!roleConfigurationData);
        //console.log("Addresses: ", addresses);
        //console.log("Payments: ", payments);
        
        setQueryFields({
            cbCustomerId: cbCustomerId,
            bpCode: bpCode == "--" ? undefined : bpCode,
            //idTenant: formContext.getValues("cbDetails.idTenant"),
            //oldBpCode: formContext.getValues("cbDetails.oldBpCode"),
            email: params.email || null,
            cbType: params.cbType || null,
            //dealerType: params.dealerType || null,
            //customerType: params.customerType || null,
            role: params.role || null,
            language: params.language || null,
            partnerType: params.partnerType || null,
            vip: params.vip || null,
            blacklist: params.blacklist || null,
            blacklistDescription: params.blacklistDescription || null,
            initialRegDate: params.initialRegistrationDate || null,
            finalRegDate: params.finalRegistrationDate || null,
            //legalForm: params.legalForm || null,
            bpBlocked: params.bpBlocked || null,
            contactInfo: {
                prefix: mobilePrefix || null,
                mobile : mobile, //SERVE PASSARLO SEMPRE PER I CHECK SUL BFF
                addresses: addresses.length > 0 ? addresses : undefined
            },
            paymentInfo: payments.length > 0 ? payments : undefined
        });

        //setEditing(false);
        setCbEditButtonTrigger((prev) => {
            return {...prev, cbDetails: CBEditButtonTriggerStatus.TO_UPDATE}
        });

    }

    const onSave = useCallback((event: SyntheticEvent) => {
        formContext.trigger("cbDetails").then((isValid) => {
            isValid && onSubmit(getDirtyValues(formState.dirtyFields, formContext.getValues()).cbDetails);
        }).catch((err) => {
            console.log("Err: ", err);
        });


    }, [id, formState, formContext]);

    const generateRoleConfigurationDefaultData = () => {
        if(!!roleConfigurationData){
           // console.log("CALL GENERATE BY ROLE", roleConfigurationData);
            return roleConfigurationData;

        } 

        const invoicingAddress = formContext.getValues("cbInvoicingAddress");
        const residenceAddress = formContext.getValues("cbPersonalInfo");
        const payments = formContext.getValues("cbPaymentInfo");
        const email = formContext.getValues("cbDetails.email");
        const mobilePrefix = formContext.getValues("cbDetails.mobilePrefix");
        const mobile = formContext.getValues("cbDetails.mobile");
        const addrMobile = mobile == "--" && (!mobilePrefix || mobilePrefix == "--" ) ? null : (mobilePrefix + mobile);

        var invoicingRecipientCode: string | null | undefined = null;

        if(publicAuthorityWatch == CBYesNoType.NO) {
            invoicingRecipientCode = invoicingAddress.invoicingRecipientCode == "--" ? CBInvoicingCode.DEFAULT as string : invoicingAddress.invoicingRecipientCode || CBInvoicingCode.DEFAULT as string;
        }

        const data: IRoleConfigurationFormValues = {
            invoicingAddressId: invoicingAddress.invoicingAddressId || null,
            invoicingCbCustomerId: invoicingAddress.invoicingCbCustomerId || null,
            invoicingAddressNumber: invoicingAddress.invoicingAddressNumber || null,
            invoicingStreet: invoicingAddress.invoicingStreet == "--" ? null : invoicingAddress.invoicingStreet || null,
            invoicingHouseNumber: invoicingAddress.invoicingHouseNumber == "--" ? null : invoicingAddress.invoicingHouseNumber || null,
            invoicingZipCode: invoicingAddress.invoicingZipCode == "--" ? null : invoicingAddress.invoicingZipCode || null,
            invoicingProvince: invoicingAddress.invoicingProvince == "--" ? null : invoicingAddress.invoicingProvince || null,
            invoicingCity: invoicingAddress.invoicingCity == "--" ? null : invoicingAddress.invoicingCity || null,
            invoicingCountry: invoicingAddress.invoicingCountry == "--" ? null : invoicingAddress.invoicingCountry || null,
            invoicingAddrEmail: invoicingAddress.invoicingAddrEmail == "--" ? email : invoicingAddress.invoicingAddrEmail || null,
            invoicingPec: invoicingAddress.invoicingPec == "--" ? null : invoicingAddress.invoicingPec || null,
            invoicingAddrMobile: addrMobile || null,
            invoicingTelephone: invoicingAddress.invoicingTelephone == "--" ? null : invoicingAddress.invoicingTelephone || null,
            invoicingFax: invoicingAddress.invoicingFax == "--" ? null : invoicingAddress.invoicingFax || null,
            invoicingWebsite: invoicingAddress.invoicingWebsite == "--" ? null : invoicingAddress.invoicingWebsite || null,
            invoicingCompanyFiscalCode: invoicingAddress.invoicingCompanyFiscalCode == "--" ? null : invoicingAddress.invoicingCompanyFiscalCode || null,
            //invoicingRecipientCode: invoicingAddress.invoicingRecipientCode == "--" ? CBInvoicingCode.DEFAULT as string : invoicingAddress.invoicingRecipientCode || CBInvoicingCode.DEFAULT as string,
            invoicingRecipientCode: invoicingRecipientCode,
            invoicingAddressType: invoicingAddress.invoicingAddressType == "--" ? null : invoicingAddress.invoicingAddressType || null,
            residenceAddressId: residenceAddress.residenceAddressId || null,
            residenceCbCustomerId: residenceAddress.residenceCbCustomerId || null,
            residenceAddressNumber: residenceAddress.residenceAddressNumber || null,
            residenceStreet: residenceAddress.residenceStreet == "--" ? null : residenceAddress.residenceStreet || null,
            residenceHouseNumber: residenceAddress.residenceHouseNumber == "--" ? null : residenceAddress.residenceHouseNumber || null,
            residenceZipCode: residenceAddress.residenceZipCode == "--" ? null : residenceAddress.residenceZipCode || null,
            residenceProvince: residenceAddress.residenceProvince == "--" ? null : residenceAddress.residenceProvince || null,
            residenceCity: residenceAddress.residenceCity == "--" ? null : residenceAddress.residenceCity || null,
            residenceCountry: residenceAddress.residenceCountry == "--" ? null : residenceAddress.residenceCountry || null,
            residenceAddrEmail: email || null,
            residenceAddrMobile: addrMobile || null,
            residenceAddressType: residenceAddress.residenceAddressType == "--" ? null : residenceAddress.residenceAddressType || null,
            paymentInfo: payments.filter(pay => !(pay.paymentMethod == "--" && pay.paymentTerms == "--" && pay.correspondingVariant == "--") || (!pay.paymentMethod && !pay.paymentTerms && !pay.correspondingVariant)).map(p => ({
                id: p.id || null,
                buagId: p.buagId || null,
                paymentMethod: p.paymentMethod == "--" ? null : p.paymentMethod || null,
                paymentTerms: p.paymentTerms == "--" ? null : p.paymentTerms || null,
                correspondingVariant: p.correspondingVariant == "--" ? null : p.correspondingVariant || null,
                iban: p.iban == "--" ? null : p.iban || null,
                accountHolder: p.accountHolder == "--" ? null : p.accountHolder || null,
                referenceDetails: p.referenceDetails == "--" ? null : p.referenceDetails || null
            })) || []
        };
        //console.log("CALL GENERATE BY FORM", data);
        return data;
   };

   useEffect(() => {
    if(openRoleConfigurationModal.open)
        setDefaultRoleconfigurationData(generateRoleConfigurationDefaultData());

   }, [openRoleConfigurationModal.open]);

   const resetRoleConfigurationMode = () => {
        setRoleConfigurationData(null);
        setDefaultRoleconfigurationData(null);
        setOpenRoleConfigurationModal({
            open: false,
            showIcon: false
        });
   }*/
   /** */

   const triggerFormValidation = () => {
        formContext.trigger().then((isValid) => {
            if(!isValid) {
                formContext.trigger("cbDetails").then((isValid) => {
                    setErrorSection((prev) => {
                        return {...prev, ["cbDetails"]: !isValid}
                    });
                });
                formContext.trigger("cbPersonalInfo").then((isValid) => {
                    setErrorSection((prev) => {
                        return {...prev, ["cbPersonalOrganizationInfo"]: !isValid}
                    });
                });
                formContext.trigger("cbInvoicingAddress").then((isValid) => {
                    setErrorSection((prev) => {
                        return {...prev, ["cbInvoicingAddress"]: !isValid}
                    });
                });
                formContext.trigger("salesAreas").then((isValid) => {
                    setErrorSection((prev) => {
                        return {...prev, ["salesAreas"]: !isValid}
                    });
                });
                formContext.trigger("cbPaymentInfo").then((isValid) => {
                    setErrorSection((prev) => {
                        return {...prev, ["cbPaymentInfo"]: !isValid}
                    });
                });

                if(formContext.getValues("cbDetails.partnerType") == CBPartnerType.ORGANIZATION) {
                    formContext.trigger("cbCorporateInfo").then((isValid) => {
                        setErrorSection((prev) => {
                            return {...prev, ["cbCorporateInfo"]: !isValid}
                        });
                    });
                }

            } else {
                setErrorSection({
                    cbDetails: false,
                    cbPersonalOrganizationInfo: false,
                    cbInvoicingAddress: false,
                    salesAreas: false,
                    cbPaymentInfo: false,
                    cbCorporateInfo: false
                });
            }
        });

   }

    return (
        <>
            <Accordion defaultExpanded
            /** Edit a Sezioni */
            /*expanded={isExpanded} onChange={(_e, onExpanding) => {

                if(!editing) {
                    if(!isCreationMode && formState.dirtyFields.cbDetails) setOpenCustomerBaseModal(true);
                    else {
                        setIsExpanded(onExpanding);
                        setEditing(false);
                    }
                }
            }}*//** */>
                <AccordionSummary expandIcon={<ExpandMore/>}>
                    {//isCreationMode ? (isPerson ? t('tabs.accordionsLabels.cbDetails') : t('tabs.accordionsLabels.cbOrganizationDetails')) : 
                        <UpdateBtnsAccordion
                            section="cbDetails"
                            label={isCreationMode ? (isPerson ? t('tabs.accordionsLabels.cbDetails') : t('tabs.accordionsLabels.cbOrganizationDetails')) 
                                : (isPerson ? t('tabs.accordionsLabels.cbDetails') : t('tabs.accordionsLabels.cbOrganizationDetails'))
                            }
                            editing={!isCreationMode && editing}
                            /** Edit a Sezioni */
                            //isExpanded={isExpanded}
                            //disabledSave={formState.dirtyFields.cbDetails ? false : true}
                            //onSetEditing={onSetEditing}
                            //onResetForm={onResetForm}
                            //onSave={onSave}
                            //showCustomIcon={openRoleConfigurationModal.showIcon}
                            //customIcon={<ContactEmergencyRoundedIcon fontSize="small"/>}
                            //tooltipTitleCustomIcon={t("roleConfigurationModal.tooltip")}
                            /*onClickCustomIcon={(_event) => setOpenRoleConfigurationModal({
                                open: true,
                                showIcon: true
                            })}*/
                            /** */
                        />
                    }
                </AccordionSummary>
                <AccordionDetails>
                    
                    <Grid container columnSpacing={3} rowSpacing={1}>
                        {!isCreationMode && <Grid item md={6} xs={12}>
                            <CBFormTextFieldController 
                                formName={"cbDetails.cbCustomerId"}
                                label={"cbCustomerId"}
                                readOnly
                                isDisabled={editing}
                            />
                        </Grid>}
                        {!isCreationMode && <Grid item md={6} xs={12}>
                            <CBFormTextFieldController 
                                formName={"cbDetails.bpCode"}
                                label={"bpCode"}
                                readOnly
                                isDisabled={editing}
                            />
                        </Grid>}
                        {!isCreationMode && <Grid item md={6} xs={12}>
                            <CBFormTextFieldController 
                                formName={"cbDetails.oldBpCode"}
                                label={"oldBpCode"}
                                readOnly
                                isDisabled={editing}
                            />
                        </Grid>}
                        { !isCreationMode && <Grid item md={6} xs={12}>
                            <CBFormTextFieldController 
                                formName={"cbDetails.idTenant"}
                                label={"idTenant"}
                                readOnly
                                isDisabled={editing}
                            />
                        </Grid>}
                        <Grid item md={6} xs={12}>
                            <CBFormTextFieldController 
                                formName={"cbDetails.email"}
                                label={"email"}
                                readOnly={isCreationMode ? false : !editing}
                                required
                                onBlur={() => handleCheckCustomerExistenceOnBlur(CBLabel.EMAIL_LABEL_CHECK)}
                            />
                        </Grid>
                        <Grid item container md={6} xs={12} columnSpacing={1}>
                            <Grid item md={5} xs={12}>
                                {(isCreationMode || editing) ?
                                    <Controller 
                                        control={formContext.control}
                                        name="cbDetails.mobilePrefix"
                                        render={({field, fieldState}) => (
                                            <Autocomplete 
                                                fullWidth
                                                openOnFocus
                                                autoHighlight
                                                //autoSelect
                                                id="cb-details-mobile-prefix"
                                                options={mobilePrefixes}
                                                renderInput={(params) => (
                                                    <TextField
                                                        label={t("mobilePrefix") + " *"}
                                                        {...params}
                                                        error={Boolean(fieldState.error)}
                                                        helperText={fieldState.error?.message}
                                                    />
                                                )}
                                                filterOptions={(options, state) => {
                                                    const { inputValue } = state;
                                                    return options.filter((mp) => mp.country.toLowerCase().includes(inputValue.toLowerCase()));
                                                }}
                                                renderOption={(props, option) => {
                                                    return (
                                                        <Box component="li" {...props} key={option?.country + option?.prefix} ml={1} mr={1}>
                                                            {option?.country} {'('}+{option?.prefix}{')'}
                                                        </Box>
                                                    )
                                                }}
                                                value={field.value? mobilePrefixes.find((c) => ("+" + c.prefix == field.value)) || null : null}
                                                getOptionLabel={(option) => "+" + option.prefix}
                                                onChange={(_event, value) => {
                                                    field.onChange("+" + value?.prefix);
                                                }}
                                            /> 
                                        )}
                                    />
                                    :
                                    <Controller 
                                        control={formContext.control}
                                        name="cbDetails.mobilePrefix"
                                        render={({field}) => (
                                            <TextField
                                                id="cb-details-mobile-prefix-textfield"
                                                fullWidth
                                                InputProps={{
                                                    readOnly: true
                                                }}
                                                label={t("mobilePrefix") + " *"}
                                                value={field.value? (mobilePrefixes.find((c) => ("+" + c.prefix == field.value)) ? "+" + mobilePrefixes.find((c) => ("+" + c.prefix == field.value))?.prefix : "--") || "--" : "--"}
                                            />
                                        )}
                                    />
                                }
                            </Grid>
                            <Grid item md={7} xs={12}>
                                <Controller 
                                    control={formContext.control}
                                    name="cbDetails.mobile"
                                    render={({field, fieldState}) => (
                                        <TextField
                                            {...field}
                                            fullWidth
                                            InputProps={{
                                                readOnly: isCreationMode ? false : !editing,
                                                autoComplete: 'none'
                                            }}
                                            id="mobile"
                                            label={t("mobile") + ' *'}
                                            //type="text"
                                            value={field.value}
                                            onChange={(event) => {
                                                if(event.target.value.match(/(^\+?[0-9]+$|^$|^\s$|^-*$)/))
                                                    field.onChange(event.target.value);
                                            }}
                                            error={Boolean(fieldState.error)}
                                            helperText={fieldState.error?.message}
                                        />
                                    )}
                                />
                            </Grid>
                        </Grid>
                        {/* PER ORA È SEMPRE NASCOSTO*//*<Grid item md={6} xs={12}>
                            <TextField
                                fullWidth
                                InputProps={{
                                    readOnly: true
                                }}
                                id="cbType"
                                label={t("cbType")}
                                type="text"
                                {...formContext.register("cbDetails.cbType")}
                                error={Boolean(formState.errors.cbDetails?.cbType)}
                                helperText={formState.errors.cbDetails?.cbType?.message}
                            />
                        </Grid>*/
                        }
                        {/*!isPerson && <Grid item md={6} xs={12}>
                            <FormController 
                                formName="cbDetails.dealerType"
                                label="dealerType"
                                options={sapEnum.dealerTypes || []}
                                showSelect={isCreationMode || editing}
                            />
                        </Grid>
                        */}
                        {/*!isPerson && <Grid item md={6} xs={12}>
                            <FormController 
                                formName="cbDetails.customerType"
                                label="customerType"
                                options={sapEnum.customerTypes || []}
                                showSelect={isCreationMode || editing}
                            />
                        </Grid>*/}
                        {
                        <Grid item md={6} xs={12}>
                            {(isCreationMode || editing) ?
                                <Controller 
                                    control={formContext.control}
                                    name={"cbDetails.role"}
                                    render={({field, fieldState}) => (
                                        <Autocomplete
                                            fullWidth
                                            multiple
                                            openOnFocus
                                            autoHighlight
                                            disabled = {isMobilityVoucherMode}
                                            //autoSelect
                                            options={sapEnum.roles}
                                            renderInput={(params: any) => 
                                                <TextField 
                                                    {...params}
                                                    fullWidth
                                                    label={t("role")}
                                                    required
                                                    error={Boolean(fieldState.error)}
                                                    helperText={fieldState.error?.message}
                                                />
                                            }
                                            value={field.value ? sapEnum.roles.filter((c) => field.value?.includes(c.value)) : []}
                                            getOptionLabel={(option:any) => option?.key}
                                            onChange={(_event, value) => {
                                                field.onChange(value);
                                                let v = value?.map((val) => val?.value).filter(Boolean) || [];
                                                formContext.setValue("cbDetails.role", v);
                                                
                                                /** Invoicing Recipient Code Logic */
                                                if(formContext.getValues("cbInvoicingAddress.invoicingCountry") != CBCountry.FRANCE) {
                                                    if(v.includes(CBRoleKey.SOLD_TO_PARTY)) {
                                                        if(isCreationMode || (editing && !formState.defaultValues?.cbDetails?.role?.includes(CBRoleKey.SOLD_TO_PARTY))){

                                                            const currInvoicingRecipientCode = formContext.getValues("cbInvoicingAddress.invoicingRecipientCode");
                                                            if((publicAuthorityWatch == CBYesNoType.NO) && ((isCreationMode && !currInvoicingRecipientCode) ||
                                                                (editing && (!currInvoicingRecipientCode || (currInvoicingRecipientCode == CBOmissionType.OMISSION_DASH)))))
                                                                    formContext.setValue("cbInvoicingAddress.invoicingRecipientCode", CBInvoicingCode.DEFAULT);
                                                        }
                                                    }  
                                                    else if(isCreationMode || (editing && !formState.defaultValues?.cbDetails?.role?.includes(CBRoleKey.SOLD_TO_PARTY))){
                                                            formContext.resetField("cbInvoicingAddress.invoicingRecipientCode");    
                                                    }
                                                } else {
                                                    formContext.resetField("cbInvoicingAddress.invoicingRecipientCode");   
                                                }

                                                if(((isCreationMode && formContext.getValues("cbDetails.cbCustomerId") || editing)) && !v.includes(CBRoleKey.SOLD_TO_PARTY)) {
                                                    setDefaultBuagClasses([]);
                                                }
                                                /** */

                                                triggerFormValidation();
                                            }}
                                        />
                                    )}
                                />
                                :
                                <Controller
                                    control={formContext.control}
                                    name={"cbDetails.role"}
                                    render={({field}) => (
                                        <TextField
                                            fullWidth
                                            InputProps={{
                                                readOnly: true
                                            }}
                                            disabled={editing}
                                            label={t("role")}
                                            //value={field.value? field.value.map((v) => sapEnum.roles.find((c) => c.value === v)?.key).filter(Boolean).join(", ") || "--" : "--"}
                                            value={field.value? field.value.map((v) => sapEnum.roles.find((c) => c.value === v)?.key).filter(Boolean).join(", ") || "--" : "--"}
                                        />
                                    )}
                                />
                            }                     
                        </Grid>
                        }
                        <Grid item md={6} xs={12}>
                            <FormController 
                                formName="cbDetails.language"
                                label="language"
                                options={sapEnum.languages || []}
                                showSelect={isCreationMode || editing}
                                sendValue
                                isMandatory
                            />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <FormController 
                                formName="cbDetails.partnerType"
                                label="partnerType"
                                options={sapEnum.partnerTypes || []}
                                showSelect={false}
                                sendValue
                                disabled={isCreationMode || editing}
                            />
                        </Grid>
                        <Grid item md={6} xs={12}>
                            <FormController 
                                formName="cbDetails.vip"
                                label="vip"
                                options={sapEnum.vips || []}
                                translationLabel="sapEnum.vips"
                                showSelect={isCreationMode || editing}
                                sendValue
                            />
                        </Grid>
                        
                        {formContext.getValues("salesAreas")?.some((sa: any) => sa.salesOrganization === CBCountryExtended.FRANCE) && (
                        <Grid item md={6} xs={12}>
                            <FormController 
                                formName="cbDetails.extMgmtReason"
                                label="extMgmtReason"
                                translationLabel="sapEnum.extMgmtReasonTypes"
                                options={sapEnum.extMgmtReason.map(v => ({ key: v.key, value: v.key }))}
                                showSelect={isCreationMode || editing}
                                sendValue
                            />
                        </Grid>
                        )}
                        {/*02/10/23: SI NASCONDE
                        !isCreationMode && 
                            <Grid item md={6} xs={12}>
                                <FormController 
                                    formName="cbDetails.blacklist"
                                    label="blacklist"
                                    options={sapEnum.blacklists || []}
                                    showSelect={isCreationMode || editing}
                                    disabled={editing}
                                    sendValue
                                />
                            </Grid>
                        */}
                        {/*02/10/23: SI NASCONDE
                        !isCreationMode && 
                            <Grid item md={6} xs={12}>
                                <CBFormTextFieldController 
                                    formName={"cbDetails.blacklistDescription"}
                                    label={"blacklistDescription"}
                                    readOnly
                                    isDisabled={editing}
                                />
                            </Grid>
                        */}
                        {!isCreationMode && <Grid item md={6} xs={12}>
                            <Controller
                                control={formContext.control}
                                name={"cbDetails.initialRegistrationDate"}
                                render={({field, fieldState}) =>
                                    <DateTimePicker
                                        readOnly={!isCreationMode}
                                        label={t("initialRegistrationDate")}
                                        value={field.value == "--" ? null : field.value}
                                        onChange={(value)=>{
                                            field.onChange(dayjs(value).format("YYYY-MM-DDTHH:mm:ssZ"));
                                        }}
                                        inputFormat={"DD-MM-YYYY HH:mm"}
                                        ampm={false}
                                        renderInput={(params: any) => (
                                            <TextField
                                                disabled={!isCreationMode}
                                                id="initialRegistrationDate"
                                                variant="standard"
                                                fullWidth
                                                label={t("initialRegistrationDate")}
                                                {...params}
                                                error={Boolean(fieldState.error)}
                                                helperText={fieldState.error?.message}
                                            />
                                        )} 
                                    />
                                }
                            />
                        </Grid>
                        }
                        {!isCreationMode && <Grid item md={6} xs={12}>
                            <Controller 
                                control={formContext.control}
                                name={"cbDetails.finalRegistrationDate"}
                                render={({field}) => 
                                    <DateTimePicker
                                        readOnly={isCreationMode ? false : !editing}
                                        label={t("finalRegistrationDate")} 
                                        value={field.value == "--" ? null : (field.value || null)}
                                        onChange={(value) => {
                                            field.onChange(dayjs(value).format("YYYY-MM-DDTHH:mm:ssZ"));
                                        }}
                                        inputFormat={"DD-MM-YYYY HH:mm"}
                                        InputProps={{
                                            autoComplete: 'none'
                                        }}
                                        ampm={false}
                                        renderInput={(params: any) => (
                                            <TextField 
                                                fullWidth
                                                id="finalRegistrationDate"
                                                label={t("finalRegistrationDate")}
                                                {...params}
                                            />
                                        )}
                                    />
                                }
                            />
                        </Grid>
                        }
                        {/*!isPerson && <Grid item md={6} xs={12}>
                            <FormController 
                                formName="cbDetails.legalForm"
                                label="legalForm"
                                options={sapEnum.legalForms || []}
                                showSelect={isCreationMode || editing}
                                isMandatory
                                handleAdditionalBehaviourOnChange={(_value) => {
                                    if(isCreationMode && !isPerson)
                                        formContext.trigger(["cbPersonalInfo.vatNumberCountry", "cbPersonalInfo.vatNumber", "cbPersonalInfo.taxCode"]);
                                }}
                            />
                        </Grid>
                        */}
                        {!isCreationMode &&
                            <Grid item md={6} xs={12}>
                                <CBFormTextFieldController 
                                    formName={"cbDetails.bpBlocked"}
                                    label={"bpBlocked"}
                                    readOnly
                                    isDisabled={editing}
                                />
                            </Grid>
                        }
                        {!isCreationMode && <Grid item md={6} xs={12}>
                            <CBFormTextFieldController 
                                formName={"cbDetails.idpUid"}
                                label={"idpUid"}
                                readOnly
                                isDisabled={editing}
                            />
                        </Grid>
                        }
                    </Grid>
                </AccordionDetails>
            </Accordion>
            {/** Edit a Sezioni */
            /*<CBRoleConfigurationModal 
                isOpen={openRoleConfigurationModal.open}
                defaultData={defaultRoleConfigurationData}
                onConfirm={(configurationData) => {
                    console.log("Role Config Data: ", configurationData);
                    setRoleConfigurationData(configurationData);
                    setOpenRoleConfigurationModal({
                        open: false,
                        showIcon: true
                    });
                }}
                onClose={() => {
                    formContext.setValue("cbDetails.role", formContext.getValues("cbDetails.role").filter(r => r !== CBRoleKey.SOLD_TO_PARTY));
                    resetRoleConfigurationMode();
                    
                }}
            />*/}
        </>
    );
}

export default CustomerBaseDetails;